import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FaceSparkleIcon, WaterDropIcon, VialIcon, PenNeedleIcon, BodySilhouetteIcon, SunLaserIcon, SparkTweezerIcon, LipsIcon, IVBagIcon, CheckIcon, LightbulbIcon } from './icons/Icons';
const servicesData = [{
  id: '01',
  title: 'Limpieza Facial Profunda',
  tagline: 'El reset que tu piel pide cada mes',
  icon: FaceSparkleIcon,
  description: 'Tu piel habla. Y cuando dice "estoy cansada, cargada, opaca" — la limpieza facial profunda es la respuesta. Este tratamiento elimina en profundidad todo lo que se acumula: impurezas, exceso de grasa, células muertas, toxinas diarias. El resultado desde la primera sesión: una piel que respira, que brilla, que se siente como nueva.',
  bullets: ['Limpieza profunda de poros', 'Eliminación de impurezas y exceso de grasa', 'Mejora inmediata en textura y luminosidad', 'Sensación de frescura y ligereza instantánea'],
  tip: 'Recomendada cada 4 semanas para mantener tu piel en óptimo estado.'
}, {
  id: '02',
  title: 'HydraFacial',
  tagline: 'Limpieza + Hidratación + Glow — en una sola sesión',
  icon: WaterDropIcon,
  description: 'El HydraFacial no es un facial convencional. Es una experiencia de transformación en tres pasos simultáneos: limpia, exfolia y nutre tu piel al mismo tiempo — sin irritación, sin downtime, sin necesidad de esconderte después del tratamiento. Sales del studio con la piel lista para ser vista.',
  bullets: ['Limpieza y exfoliación profunda no abrasiva', 'Extracción de impurezas sin dolor', 'Infusión de sueros hidratantes y antioxidantes', 'Resultados inmediatos y visibles', 'Sin tiempo de recuperación'],
  tip: 'Ideal para antes de eventos, ocasiones especiales o simplemente porque te lo mereces.'
}, {
  id: '03',
  title: 'Plasma Rico en Plaquetas (PRP)',
  tagline: 'Tu propio cuerpo. Tu mejor tratamiento.',
  icon: VialIcon,
  description: 'Imagina un tratamiento que usa tu propio plasma para regenerar, rejuvenecer y transformar tu piel — de adentro hacia afuera. El PRP (Plasma Rico en Plaquetas) es la tecnología más avanzada en regeneración natural. Sin químicos externos. Sin riesgo de rechazo. Solo tu cuerpo trabajando a su máximo potencial.',
  bullets: ['Estimula la regeneración celular profunda', 'Reduce inflamación y acelera recuperación', 'Rejuvenecimiento facial visible y natural', 'Estimula el crecimiento capilar', 'Minimiza riesgos al ser 100% autólogo', 'Mejora la movilidad articular', 'Complemento ideal en postoperatorios'],
  tip: 'El tratamiento favorito de quienes buscan resultados reales sin cirugía.'
}, {
  id: '04',
  title: 'Microneedling (Dermapen)',
  tagline: 'Ciencia que se ve en tu espejo',
  icon: PenNeedleIcon,
  description: 'Miles de microcanales. Una piel completamente renovada. El Microneedling con Dermapen activa la producción natural de colágeno en las capas profundas de tu piel — reduciendo cicatrices, líneas finas, poros dilatados y devolviendo firmeza real a tu rostro. No es magia. Es biología. Y los resultados son extraordinarios.',
  bullets: ['Estimulación profunda de colágeno y elastina', 'Reducción visible de cicatrices de acné', 'Minimización de poros dilatados', 'Mejora de líneas finas y arrugas tempranas', 'Textura más suave y uniforme', 'Luminosidad natural potenciada'],
  tip: 'Resultados progresivos y duraderos. Cada sesión es mejor que la anterior.'
}, {
  id: '05',
  title: 'Blanqueamientos Corporales e Íntimos',
  tagline: 'Tu cuerpo entero merece cuidado y atención',
  icon: BodySilhouetteIcon,
  description: 'La hiperpigmentación en zonas íntimas y corporales es más común de lo que se habla — y tiene solución. Con total discreción, profesionalismo y técnicas seguras, unificamos el tono de tu piel en las zonas más sensibles de tu cuerpo.',
  bullets: ['Unificación del tono en zonas oscuras', 'Tratamiento seguro para piel sensible', 'Procedimiento discreto y profesional', 'Resultados visibles y progresivos'],
  tip: 'Porque cuidarte no tiene zonas de excepción.'
}, {
  id: '06',
  title: 'Laser',
  tagline: 'Borra lo que no quieres. Revela lo que siempre estuvo ahí.',
  icon: SunLaserIcon,
  description: 'La tecnología láser de Skin Glow Studio 22 trabaja con precisión clínica para tratar lo que más te preocupa — manchas, pigmentación, acné, cicatrices, rosácea, y vello no deseado. Sin bisturí. Sin tiempo de recuperación prolongado. Con resultados que hablan solos.',
  bullets: ['Reducción de manchas y pigmentación', 'Unificación del tono de piel', 'Tratamiento de rosácea y acné activo', 'Mejora de cicatrices y textura irregular', 'Estimulación de colágeno', 'Depilación láser — resultados duraderos'],
  tip: 'Menos irritación. Más suavidad. Resultados que tu piel te agradecerá.'
}, {
  id: '07',
  title: 'Cauterización de Verrugas',
  tagline: 'Rápido. Preciso. Definitivo.',
  icon: SparkTweezerIcon,
  description: 'Esas lesiones que llevan tiempo incomodándote tienen solución — y es más rápida de lo que imaginas. La cauterización de verrugas es un procedimiento seguro, preciso e higiénico que elimina la lesión sin dañar la piel circundante, con recuperación mínima y resultados desde la primera sesión.',
  bullets: ['Eliminación precisa y segura', 'Procedimiento rápido — misma sesión', 'Recuperación mínima', 'Realizado por manos certificadas', 'Sin daño a la piel circundante'],
  tip: 'Di adiós a lo que te incomoda. Hoy mismo.'
}, {
  id: '08',
  title: 'Lip Blush',
  tagline: 'Labios perfectos. Sin lápiz. Sin esfuerzo diario.',
  icon: LipsIcon,
  description: 'Color natural. Definición perfecta. Una sonrisa que se nota desde que entras a un cuarto. El Lip Blush es la pigmentación semipermanente que realza el color natural de tus labios, define su forma y les devuelve esa vida y frescura que el tiempo o el sol pueden opacar. Una vez. Resultados que duran.',
  bullets: ['Color natural y definido sin maquillaje', 'Simetría y forma perfecta', 'Efecto fresco y armonioso', 'Pigmentación segura y semipermanente', 'Realza tu belleza natural sin exagerar'],
  tip: 'Para la mujer que quiere despertar perfecta — sin esfuerzo.'
}, {
  id: '09',
  title: 'IV Therapy — Sueroterapia',
  tagline: 'Bienestar total. Desde adentro hacia afuera.',
  icon: IVBagIcon,
  description: 'La verdadera belleza empieza desde dentro. La IV Therapy (Sueroterapia) es el tratamiento intravenoso de vitaminas, minerales, antioxidantes y nutrientes esenciales que tu cuerpo necesita para funcionar — y verse — en su mejor versión. En minutos, tu cuerpo recibe exactamente lo que le falta. El resultado: energía, hidratación, luminosidad y bienestar que se notan desde la primera sesión.',
  bullets: ['Hidratación profunda a nivel celular', 'Aporte directo de vitaminas y antioxidantes', 'Energía y vitalidad restauradas', 'Luminosidad en piel desde adentro', 'Apoyo al sistema inmune', 'Recuperación acelerada', 'Bienestar total — cuerpo y mente'],
  tip: 'No es solo estética. Es salud. Es la inversión más inteligente en ti misma.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export const Services = () => {
  return <section id="servicios" className="py-12 md:py-16 bg-brand-pink relative" data-id="element-356">
      <div className="container mx-auto px-6" data-id="element-357">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-12" data-id="element-358">
          <div className="flex justify-center mb-3" data-id="element-359">
            <div className="h-px w-16 bg-brand-gold" data-id="element-360"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-3" data-id="element-361">
            Los Servicios
          </h2>
          <p className="text-xl text-brand-bronze font-serif italic mb-3" data-id="element-362">
            Tecnología, experiencia y cuidado para tu piel y bienestar
          </p>
          <p className="text-brand-charcoal/80" data-id="element-363">
            Cada tratamiento está diseñado para una sola cosa:{' '}
            <br className="hidden md:block" data-id="element-364" />
            <span className="font-medium" data-id="element-365">
              Que tu piel sea la mejor versión de sí misma.
            </span>
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-366">
          {servicesData.map(service => <motion.div key={service.id} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-sm border border-brand-cream hover:border-brand-gold/40 hover:shadow-md transition-all duration-300 group relative overflow-hidden flex flex-col h-full" data-id="element-367">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-brand-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-368"></div>

              <div className="relative z-10 flex-grow" data-id="element-369">
                <div className="flex items-start justify-between mb-6" data-id="element-370">
                  <div className="w-14 h-14 rounded-full bg-brand-blush border border-brand-gold/20 flex items-center justify-center text-brand-gold group-hover:scale-110 transition-transform duration-300" data-id="element-371">
                    <service.icon size={28} data-id="element-372" />
                  </div>
                  <span className="text-3xl font-serif text-brand-sand font-light" data-id="element-373">
                    {service.id}
                  </span>
                </div>

                <h3 className="text-2xl font-serif text-brand-charcoal mb-2 group-hover:text-brand-bronze transition-colors" data-id="element-374">
                  {service.title}
                </h3>
                <p className="text-sm font-medium text-brand-gold mb-4" data-id="element-375">
                  {service.tagline}
                </p>
                <p className="text-brand-charcoal/70 text-sm leading-relaxed mb-6" data-id="element-376">
                  {service.description}
                </p>

                <div className="space-y-3 mb-8" data-id="element-377">
                  <p className="text-xs font-medium text-brand-charcoal uppercase tracking-wider" data-id="element-378">
                    Lo que hace por ti:
                  </p>
                  <ul className="space-y-2" data-id="element-379">
                    {service.bullets.map((bullet, idx) => <li key={idx} className="flex items-start text-sm text-brand-charcoal/80" data-id="element-380">
                        <div className="text-brand-gold mt-0.5 mr-2 flex-shrink-0" data-id="element-381">
                          <CheckIcon size={14} data-id="element-382" />
                        </div>
                        <span className="leading-tight" data-id="element-383">{bullet}</span>
                      </li>)}
                  </ul>
                </div>
              </div>

              <div className="relative z-10 mt-auto pt-6 border-t border-brand-cream" data-id="element-384">
                <p className="text-sm text-brand-charcoal/90 font-serif italic flex items-start" data-id="element-385">
                  <span className="text-brand-gold mr-2 mt-0.5 flex-shrink-0 not-italic" data-id="element-386">
                    <LightbulbIcon size={14} data-id="element-387" />
                  </span>
                  {service.tip}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};